import { FIELD_CHEVRON } from '~/theme/fieldSizing';

/**
 * A downward stroke chevron, drawn in the current colour. Takes a
 * `className` so a Select can place and turn it.
 */
export default function ChevronDownIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width={FIELD_CHEVRON.size}
            height={FIELD_CHEVRON.size}
            viewBox="0 0 12 12"
            fill="none"
            aria-hidden
        >
            <path
                d="M3 4.5l3 3 3-3"
                stroke="currentColor"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
